__turbopack_context__.v({
  "header": "SiteHeader-module__Y5MWMG__header",
  "theme-toggle-pop": "SiteHeader-module__Y5MWMG__theme-toggle-pop",
  "themeIcon": "SiteHeader-module__Y5MWMG__themeIcon",
  "themeIconAnimating": "SiteHeader-module__Y5MWMG__themeIconAnimating",
});
